import { Controller } from "@hotwired/stimulus"
import UrlParamsManager from "../concern/url_params_manager";
import findScrollParent from "../concern/find_scroll_parent"
import HighlightTranscript from "../concern/highlight_transcript"


// Connects to data-controller="highlight-transcript"
export default class extends Controller {
  static targets = ["trigger", "effect", "observe"]
  static values = {
    casts: Array,
    selected: Array,
    markText: String,
  }

  connect() {
    this.init()
  }

  disconnect() {
    this.visibleElements = null
    this.highlighter = null
    this.observer.disconnect()
  }

  triggerTargetConnected(target) {
    this.highlighter?.applyHighlight(target)
  }

  effectTargetConnected(target) {
    this.highlighter?.applyHighlight(target)
  }

  init() {
    this.urlManager = new UrlParamsManager("highlight");
    this.selectedValue = this.urlManager.getValues()
    this.highlighter = new HighlightTranscript({
      casts: this.castsValue,
      selected: this.selectedValue,
      markText: this.markTextValue,
    })
    this.#setObserver()
  }

  observeTargetConnected(target) {
    if (target) {
      this.observer?.observe(target)
    }
  }

  selectedValueChanged() {
    this.#refreshHighlight()
  }

  castsValueChanged() {
    this.highlighter?.updateCasts(this.castsValue, this.selectedValue)
    this.#refreshHighlight()
  }

  markTextValueChanged() {
    this.highlighter?.updateMarkText(this.markTextValue)
    this.#refreshHighlight()
  }

  #setObserver() {
    this.visibleElements = new Set()
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const elem = entry.target
          if (entry.isIntersecting) {
            this.visibleElements.add(elem)
            this.highlighter.applyHighlight(elem)
          } else {
            this.visibleElements.delete(elem)
          }
        })
      },
      {
        root: findScrollParent(this.element),
        rootMargin: '300px 0px'
      }
    )
    if (this.hasObserveTarget) {
      this.observeTargets.forEach((target) => {
        this.observer.observe(target)
      })
    }
  }

  #refreshHighlight() {
    if (this.visibleElements) {
      this.visibleElements.forEach(elem => {
        this.highlighter.applyHighlight(elem)
      })
    }
  }

  toggle(event) {
    const cast = event.target.dataset.castName
    if (!cast) {
      console.warn("No data-cast-name attribute found on element")
      return
    }

    this.selectedValue = this.highlighter.toggleCast(cast)
    this.urlManager.setValues(this.selectedValue)
  }
}
